export default __webpack_public_path__ + "static/media/icon_cat_WeddingBands.171d4279.png";